module.exports = __webpack_public_path__ + "static/img/programme_educloud.a218400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_educloud.jpg
// module id = Y6PB
// module chunks = 0